import {CheckboxSwitch} from "../../core/components/checkbox/checkboxSwitch";
import {Localizer} from "../../infrastructure/localization/localizer";
import {Dropdown, DropdownOption} from "../../core/components/dropdown/dropdown";
import React, {useEffect, useState} from "react";
import {MultiValue} from "react-select";
import {toDropdownOptions} from "../../core/sharedmodels/forSelectModel";
import useStamdataApi from "../../core/hooks/useStamdataApi";
import {LoadingCircle} from "./loadingCircle";
import {DashboardConstants} from "./dashboardConstants";
import useScreenResolution from "../../core/hooks/useScreenResolution";
import classNames from "classnames";
import {DashboardFilterModel} from "./models/DashboardFilter";

type DashboardFiltersProps = {
    filter: DashboardFilterModel;
    setFilter: React.Dispatch<React.SetStateAction<DashboardFilterModel>>
    initialFetchRef: React.MutableRefObject<boolean>;
}

export const DashboardFilters = ({filter, setFilter, initialFetchRef}: DashboardFiltersProps) => {
    const {isMobile} = useScreenResolution();
    const {stamdataSpecialeApi, stamdataAfdelingApi, stamdataLaegeinstitutionApi} = useStamdataApi();

    const [specialeOptions, setSpecialeOptions] = useState<DropdownOption<string>[]>([]);
    const [uddannelsesstederOptions, setUddannelsesstederOptions] = useState<DropdownOption<string>[]>([]);

    useEffect(() => {
        const fetchSpecialeOptions = async () => {
            return await stamdataSpecialeApi.getSpecialerSelect()
        }
        const fetchUddannelsesstederOptions = async () => {
            const afdelinger = await stamdataAfdelingApi.getAfdelingerSelect();
            const praksisser = await stamdataLaegeinstitutionApi.getPraksisSelect();
            return afdelinger.concat(praksisser).sortBy(x => x.text);
        }
        fetchSpecialeOptions().then((response) => {
            setSpecialeOptions(toDropdownOptions(response));
        });
        fetchUddannelsesstederOptions().then((response) => {
            setUddannelsesstederOptions(toDropdownOptions(response));
        });
    }, [stamdataAfdelingApi, stamdataLaegeinstitutionApi, stamdataSpecialeApi])

    const handleSpecialerChange = (value: MultiValue<DropdownOption<string>>) => {
        const specialer = value.map(x => x.value);
        setFilter((prev) => ({...prev, specialeIds: specialer}))
    };

    const handleUddannelsesstederChange = (value: MultiValue<DropdownOption<string>>) => {
        const uddannelsessteder = value.map(x => x.value);
        setFilter((prev) => ({...prev, uddannelsesstedIds: uddannelsessteder}))
    };

    const onIncludeOrlovChange = (value: boolean) => {
        setFilter((prev) => ({...prev, includeOrlov: value}))
    };

    return (
        <div className={"flex-container-row wrap margin-bottom-s align-content-center"}>
            {!initialFetchRef.current &&
                <LoadingCircle duration={DashboardConstants.FilterTimer}
                               filter={filter}
                               optionalText={Localizer.dashboard_applyingFilter()}
                               additionalClasses={isMobile ? "margin-top-s margin-left-s" : ""}/>
            }
            <div className={classNames("flex-container-row align-items-center margin-right-m", isMobile && "margin-s")}>
                <CheckboxSwitch
                    id={"include-orlov-dashboard"}
                    reverseTextAndSwitch
                    label={Localizer.dashboard_includeUddannelseslaegerOnOrlov()}
                    onChange={(e) => onIncludeOrlovChange(e.target.checked)}
                    value={filter?.includeOrlov}
                />
            </div>
            <Dropdown
                className={classNames("margin-right-m", isMobile && "margin-left-s")}
                placeholder={Localizer.global_alleSpecialer()}
                options={specialeOptions}
                closeMenuOnSelect={false}
                minWidth={"300px"}
                maxWidth={"300px"}
                renderMultiValuesAsTextAppendTextOverride={Localizer.global_specialer().toLowerCase()}
                renderMultiValuesAsText
                onChange={(newValue) => handleSpecialerChange(newValue)}
                value={specialeOptions?.filter(x => filter?.specialeIds?.includes(x.value))}
                isClearable
                isMulti
            />
            <Dropdown
                className={classNames("margin-right-m", isMobile && "margin-s")}
                closeMenuOnSelect={false}
                minWidth={"300px"}
                maxWidth={"300px"}
                renderMultiValuesAsTextAppendTextOverride={Localizer.uddannelsessteder().toLowerCase()}
                placeholder={Localizer.AlleUddannelsessteder()}
                renderMultiValuesAsText
                options={uddannelsesstederOptions}
                onChange={(newValue) => handleUddannelsesstederChange(newValue)}
                value={uddannelsesstederOptions?.filter(x => filter?.uddannelsesstedIds?.includes(x.value))}
                isClearable
                isMulti
            />
        </div>
    )
}
